import { Outlet } from "@monta/router-react";
import styles from "./layout.module.scss";

const EmptyLayout = () => {
  return (
    <div dir="rtl" id="app" className={styles["empty-layout"]}>
      <main>
        <Outlet />
      </main>
    </div>
  );
};
export default EmptyLayout;
